/******************************************************************
 * Copyright @ 2024 广州牛师帮文化科技有限公司. All rights reserverd.
 * @file   src\routes\SSO\LinkTunnel.ts
 * @author 朱剑豪
 * @date   2024/06/11 17:14
 * @desc   为“带参跳转”方式的登录提供支持
 ******************************************************************/
import { message } from "antd";
import qs from "qs";
export default class LinkTunnel {
    constructor(opts) {
        this.opts = opts;
    }
    send(key, value) {
        var _a, _b, _c, _d, _e, _f;
        switch (key) {
            case 'resolve': {
                const pool = value;
                const query_obj = {
                    orgId: (_a = pool.orgId) === null || _a === void 0 ? void 0 : _a.value,
                    userId: (_b = pool.userId) === null || _b === void 0 ? void 0 : _b.value,
                    name: (_c = pool.name) === null || _c === void 0 ? void 0 : _c.value,
                    departmentId: (_d = pool.department) === null || _d === void 0 ? void 0 : _d.value.id,
                    departmentName: (_e = pool.department) === null || _e === void 0 ? void 0 : _e.value.name,
                    token: (_f = pool.token) === null || _f === void 0 ? void 0 : _f.value,
                };
                const url = this.opts.redirect + qs.stringify(query_obj, { addQueryPrefix: true });
                location.replace(url);
                return this;
            }
            case 'error': // todo;
            case 'logout': // todo;
            case 'ready': // todo;
                return this;
            case 'reject':
                const v = value;
                if (v === 'permission_denied') {
                    message.error(`此账号无权访问${this.opts.title}`);
                }
                else if (v === 'not_login') {
                    // 不需要做什么。
                }
        }
        return this;
    }
}
